import classNames from 'classnames'

import { Icon } from '@/Atomic/Atoms/Icon'
import {
  BasicInput,
  type BasicInputProps,
} from '@/Atomic/Atoms/Inputs/BasicInput'

import './Search.scss'

interface SearchProps extends BasicInputProps {
  name: string
  searchWrapperClassName?: string
  bgColor?: 'default' | 'white'
}

export const Search: React.FC<SearchProps> = ({
  name,
  searchWrapperClassName,
  bgColor = 'default',
  ...props
}) => {
  return (
    <div
      className={classNames('search-wrapper', searchWrapperClassName, bgColor)}
    >
      <Icon icon="search" size="md" />
      <BasicInput
        name={name}
        type="text"
        inputWrapperClassName="search-bar-wrapper"
        className="search-bar"
        unstyledInputWrapper
        {...props}
      />
    </div>
  )
}
